import { PlateClassification } from '../Types';

export enum RegistrationFileSource {
  Manual = 0,
  EmailImport = 1
}

export interface RegistrationReviewItem {
  plateId: string;
  plateNumber: string;
  state: string | null;
  classification: PlateClassification;
  isMonitored: boolean;

  clientId: string;
  clientName: string;
  clientEmail: string | null;
  clientPhone: string | null;

  fileId: string;
  fileName: string;
  contentType: string;
  uploadedAt: string;
  source: RegistrationFileSource;
  sourceEmailFrom: string | null;
  sourceEmailSubject: string | null;
  sourceEmailReceivedAt: string | null;
  importNotes: string | null;

  classificationReviewedAt: string | null;
  classificationReviewedByName: string | null;
  businessNoticeSentAt: string | null;
}

export interface RegistrationReviewQueueFilter {
  monitoringListId?: string;
  clientId?: string;
  includeReviewed?: boolean;
}

export interface ClassificationReviewRequest {
  classification: PlateClassification;
  registrationFileId: string;
  reviewerName?: string;
}

export type NoticeChannelStatus = 'Sent' | 'Failed' | 'NoRecipient';

export interface NoticeChannelResult {
  status: NoticeChannelStatus;
  recipient: string | null;
  error: string | null;
}

export interface BusinessNoticeOutcome {
  attempted: boolean;
  alreadySentAt: string | null;
  sms: NoticeChannelResult | null;
  email: NoticeChannelResult | null;
}

export interface ClassificationReviewResult {
  plateId: string;
  plateNumber: string;
  previousClassification: PlateClassification;
  classification: PlateClassification;
  reviewedAt: string;
  reviewedByName: string | null;
  businessNoticeSentAt: string | null;
  notice: BusinessNoticeOutcome;
}
